import { gql } from '@apollo/client'

export const ADD_CLEARANCE_STATUS = gql`
  mutation AddClearanceStatus($inputData: ClearanceStatusInput!) {
    addClearanceStatus(inputData: $inputData) {
      id
    }
  }
`
